import { useEffect } from 'react';
import { getAmbientEngine, AmbientType } from '@/hooks/useAmbientAudio';

interface RoomAudioProps {
  category: AmbientType;
}

const RoomAudio = ({ category }: RoomAudioProps) => {
  useEffect(() => {
    const wasEnabled = localStorage.getItem('ambient-audio-enabled') === 'true';
    
    if (wasEnabled) {
      const engine = getAmbientEngine();
      engine.start(category);
    }

    return () => {
      // Don't stop on unmount - let it continue between rooms
    };
  }, [category]);

  return null;
};

export default RoomAudio;
